import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-frosty-dialog-shell',
    templateUrl: './frosty-dialog-shell.component.html',
    styleUrls: ['./frosty-dialog-shell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FrostyDialogShellComponent {
    @Input() eyebrow = '';
    @Input() title = '';
    @Input() description = '';
    @Input() bodyClass = '';
}
